<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center mb-3">
        <div class="avatar-xs me-3">
          <span
            class="
              avatar-title
              rounded-circle
              bg-soft bg-primary
              text-primary
              font-size-18
            "
          >
            <i class="mdi mdi-devices"></i>
          </span>
        </div>
        <h5 class="font-size-14 mb-0">{{ title }}</h5>
      </div>
      <apexchart
        type="bar"
        height="430"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      onlineDeviceTypes: {},
      offlineDevicesTypes: {},
      deviceTypes: {},
      title: "Device Types and Status",
      series: [
        {
          name: "Online",
          data: [],
        },
        {
          name: "Offline",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 250,
          stacked: true,
          width: "50%",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 10,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: ["#198754", "#dc3545"],
        dataLabels: {
          enabled: true,
          offsetX: -5,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          width: 2,
          colors: ["#222736"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },

  methods: {
    async devicesDetails() {
      const devices = await this.$store.getters["gis/devices"];

      // Categories of devices
      devices.forEach((element) => {
        this.deviceTypes[element.device_type] =
          (this.deviceTypes[element.device_type] || 0) + 1;
      });
      for (let value in this.deviceTypes) {
        if (value === "") {
          value = "Uncategorized";
          this.chartOptions.xaxis.categories.push(value);
        } else {
          this.chartOptions.xaxis.categories.push(value);
        }
      }

      // Online Devices
      const onlineDevices = await devices.filter(
        (onlineData) => onlineData.status === true
      );
      onlineDevices.forEach((element) => {
        this.onlineDeviceTypes[element.device_type] =
          (this.onlineDeviceTypes[element.device_type] || 0) + 1;
      });

      for (let value in this.onlineDeviceTypes) {
        this.series[0].data.push(this.onlineDeviceTypes[value]);
      }

      // Offline Devices
      const offlineDevices = await devices.filter(
        (offlineData) => offlineData.status === false
      );
      offlineDevices.forEach((element) => {
        this.offlineDevicesTypes[element.device_type] =
          (this.offlineDevicesTypes[element.device_type] || 0) + 1;
      });

      for (let value in this.offlineDevicesTypes) {
        this.series[0].data.push(this.offlineDevicesTypes[value]);
      }
    },
  },

  async mounted() {
    await this.devicesDetails();
  },
};
</script>
